import type { ReactNode } from "react";

/* ------------------------------------------------------------------ *
 * THE DEALER'S MARKER — شلم's (`ShelemTable`) until card-a7 B11 (2026-10-21), when پاسور's dealer
 * became its second user and it moved here byte for byte (the «حاکم» chip's way, `hakem-chip.tsx`):
 * a gold disc with a fanned hand of cards, on the corner of the avatar of the seat that dealt this
 * hand — `TableSeat`'s `avatarCorner` on a seat around the felt, the same corner (`AVATAR_CORNER`) of
 * your own ring in your strip when you dealt. The one thing a table decides is what it says to
 * assistive tech.
 *
 * پاسور's dealer decides who plays first (the seat after it), and the operator's play-test (card-a7):
 * its corner chip «دست‌دهنده» at the felt's top «does nothing and sits there the whole game» — so the
 * chip went and the marker rides the dealer's seat, moving with every deal.
 *
 * Which corner: the avatar's UPPER-RIGHT since card-67 B4 (both tables, seats and strip alike) — the
 * lower-right, where it sat, is an official account's tick (the operator: «The dealer marker sits on
 * the official tick when a player has one»). See `AVATAR_CORNER`.
 * ------------------------------------------------------------------ */

export function DealerMarker({ label }: { label: string }): ReactNode {
  return (
    <span
      data-testid="dealer-marker"
      role="img"
      aria-label={label}
      className="m-0 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-secondary text-ink-on-gold shadow-md"
    >
      <svg
        width={9}
        height={9}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <rect
          x="8"
          y="3"
          width="8"
          height="12"
          rx="1.5"
          transform="rotate(-26 12 21)"
          opacity="0.5"
        />
        <rect
          x="8"
          y="3"
          width="8"
          height="12"
          rx="1.5"
          transform="rotate(26 12 21)"
          opacity="0.5"
        />
        <rect x="8" y="3" width="8" height="12" rx="1.5" />
      </svg>
    </span>
  );
}
